/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { CreateOrganizationButton } from 'pages/organizations';
import { FC } from 'react';
import { Col, Row } from 'react-bootstrap';

import './Empty.scss';

type EmptyProps = {
  labels: {
    top: string;
    bottom: string;
  };
  onCreate?: () => void;
};

export const Empty: FC<EmptyProps> = ({ labels, onCreate }) => (
  <div className="d-flex flex-column align-items-center justify-content-center empty-view">
    <div className="d-none d-md-block background-image" />
    <Row className="fs-3 gap-4 p-6 text-center rounded-circle content">
      <Col xs="12">{labels.top}</Col>
      <Col xs="12">{labels.bottom}</Col>
    </Row>
    <div className="mt-5" style={{ zIndex: 1000 }}>
      {onCreate && <CreateOrganizationButton onClick={() => onCreate()} />}
    </div>
  </div>
);
